(function() {
  var prefixes = ['DS NA ', 'DS BS '];
  var selectors = [
    '.product-card__title',
    '.product__title',
    '.card__heading',
    '.product-title',
    '.card__title',
    '.cart-item__title',
    '.predictive-result__title',
    '.product-title-bc',
    '.predictive-search__item-title'
    // your actual selectors here
  ];
  var selectorString = selectors.join(',');

  function cleanTitle(el) {
    if (el.dataset.dsCleaned) return; // avoid re-processing
    var text = el.textContent.trim();
    for (var i = 0; i < prefixes.length; i++) {
      if (text.indexOf(prefixes[i]) === 0) {
        el.textContent = text.slice(prefixes[i].length);
        el.dataset.dsCleaned = 'true';
        break;
      }
    }
  }

  function cleanAll(root) {
    root.querySelectorAll(selectorString).forEach(cleanTitle);
  }

  // Initial pass
  document.addEventListener('DOMContentLoaded', function() {
    cleanAll(document);
  });

  // Watch for dynamically added/updated content (AJAX cards, quick view, filters, etc.)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // element node
          if (node.matches && node.matches(selectorString)) {
            cleanTitle(node);
          }
          if (node.querySelectorAll) {
            cleanAll(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();